import { Outlet } from "react-router-dom";
import { SettingsSidebar } from "./SettingsSidebar";
import { PageHeader } from "@/components/common/PageHeader";

export default function SettingsLayout() {
  return (
    <div className="flex h-screen bg-white">
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <PageHeader
          breadcrumbs={[
            { title: "Home", href: "/" },
            { title: "Einstellungen" }
          ]}
        />

        {/* Profile Header */}
        <div className="p-6 border-b">
          <h1 className="text-2xl font-semibold mb-2">Einstellungen</h1>
          <p className="text-gray-500">
            Verwalte deine Kontoeinstellungen und passe deine E-Mail-Präferenzen
            an.
          </p>
        </div>

        {/* Sidebar and Content */}
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <div className="w-64 border-r">
            <SettingsSidebar />
          </div>

          {/* Content */}
          <div className="flex-1 overflow-auto p-6">
            <div className="max-w-4xl">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
